import React from "react";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";
import { autoPlay } from "react-swipeable-views-utils";
import { ButtonComponent, SliderComponent } from "../../Component/Component";
import {
  Grid,
  IconButton,
  List,
  ListItemButton,
} from "@mui/material";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import outlineLogo from "../../Asset/bg/6.png";
import btnicon from "../../Asset/Icons/add-user.png";
import searchbtn from "../../Asset/Icons/searchicon.png";
import { CONNECT_WALLET, SEARCHCOLLECTIONSANDCREATORS, THEWITCHERWILDHUNT } from "../../Constant/constant";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    id:1,
    label: "San Francisco – Oakland Bay Bridge, United States",
    imgPath:
      "https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg",
  },
  {
    id:2,
    label: "The Witcher 3",
    imgPath: "https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg",
  },
  {
    id:3,
    label: "San Francisco – Oakland Bay Bridge, United States",
    imgPath:
      "https://cdn.vox-cdn.com/thumbor/2V6dYMtY4mOs3N8Qyo8MLpepA20=/93x0:1600x1005/920x613/filters:focal(93x0:1600x1005):format(webp)/cdn.vox-cdn.com/uploads/chorus_image/image/49112139/witcher3_en_wallpaper_wallpaper_10_1920x1200_1433327727.0.0.jpg",
  },
  {
    id:4,
    label: "The Witcher 3",
    imgPath: "https://pbs.twimg.com/media/FTIN491VEAAA7eQ.jpg",
  },
];

const SliderPage = () => {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleStepChange = (step) => {
    setActiveStep(step);
  };

  return (
    <Grid
      container
      sx={{
        display: "flex",
        backgroundImage: `url(${outlineLogo})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "80%",
        backgroundPositionX: "30%",
      }}
    >
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{
          paddingLeft: "20px",
          paddingTop: "35px",
          paddingRight: "0px",
          paddingBottom: "5px",
        }}
      >
        <Grid
          container
          spacing={4}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          <Grid item md={3.5} lg={3.5} xl={3.5}>
            <Box
              component="form"
              sx={{
                display: "flex",
                alignItems: "center",
                width: "100%",
                color: "white",
                background:
                  "linear-gradient(to bottom, rgb(0, 0, 0) 0%, rgb(0, 0, 0) 48%, rgb(42, 73, 150) 100%)",
                borderRadius: "30px",
                border: "1px solid gray",
                paddingLeft: "18px",
              }}
            >
              <input
                type="text"
                sx={{
                  ml: 1,
                  flex: 1,
                  color: "white",
                  fontFamily: "Inter",
                  fontSize: "10pt",
                }}
                placeholder={SEARCHCOLLECTIONSANDCREATORS}
                className="inputbase-text"
                // inputProps={{style:{color:'white'} }}
              />
              <IconButton
                type="button"
                sx={{ p: "15px", color: "white", marginRight: "10px" }}
                aria-label="search"
              >
                <img src={searchbtn} alt="search button" height="15px" />
              </IconButton>
            </Box>
          </Grid>
          <Grid item md={3} lg={3} xl={3}>
            <ButtonComponent
              sx={{
                padding: "10px",
                fontFamily: "Inter !important",
                paddingLeft: "30px",
                paddingRight: "30px",
                borderRadius: "30px",
                fontSize: "11pt",
                // border: "1px solid gray",
                textTransform: "capitalize",
              }}
              startIcon={<img src={btnicon} alt="button icon" height="20px" />}
            >
              {CONNECT_WALLET}
            </ButtonComponent>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{ maxWidth: "100%", padding: "5%" }}
      >
        <AutoPlaySwipeableViews
          axis={theme.direction === "rtl" ? "x-reverse" : "x"}
          index={activeStep}
          onChangeIndex={handleStepChange}
          enableMouseEvents
        >
          {images.map((step, index) => (
            <div key={step.id}>
              {Math.abs(activeStep - index) <= 2 ? (
                <SliderComponent
                  sx={{
                    height: "500px",
                    display: "block",
                    overflow: "hidden",
                    objectFit: "cover",
                    width: "100%",
                  }}
                  key={step.id}
                >
                  <Box
                    component="img"
                    src={step.imgPath}
                    alt={step.label}
                    sx={{ objectFit: "cover", width: "100%", height: "100%" }}
                  />
                </SliderComponent>
              ) : null}
            </div>
          ))}
        </AutoPlaySwipeableViews>
      </Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{
          backgroundColor: "#0162ea",
          height: "220px",
          zIndex: "-1",
          marginTop: "-24.8%",
          marginLeft: "3.5%",
          marginRight: "4.5%",
          width: "110%",
        }}
      ></Grid>
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        xl={12}
        sx={{
          position: "absolute",
          zIndex: 1,
          marginTop: "359px",
          marginLeft: "60px",
          width: "75%",
        }}
      >
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            sx={{ paddingLeft: "20px"}}
          >
            <MobileStepper
              steps={maxSteps}
              position="static"
              activeStep={activeStep}
              variant="dots"
              sx={(theme) => ({
                background: "transparent",
                paddingBottom: "2%",
                paddingLeft: "2%",
                width:'10vw',
                "& .MuiMobileStepper-dot": {
                  border: "1px solid #2f6df6",
                  fontSize: "5px",
                },
                "& .MuiMobileStepper-dotActive ~ .MuiMobileStepper-dot": {
                  backgroundColor: "transparent",
                },
              })}
            />
          </Grid>
          <Grid
            item
            xs={5}
            sm={5}
            md={5}
            lg={5}
            xl={5}
            sx={{
              background:
                "linear-gradient(115deg, rgba(25, 61, 87, 0.81) 0%, rgba(29, 43, 73, 0.56) 50%, rgba(33, 27, 60, 0.98) 100%)",
              borderRadius: " 0px 100px 100px 0px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <div className="inner">
              <div className="line right"></div>
            </div>
            <Box sx={{ paddingLeft: "20px" }}>
              <List>
                <ListItemButton>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      flex: "100%",
                      alignItems: "center",
                    }}
                  >
                    <PlayCircleOutlineIcon sx={{ color: "#2f6df6" }} />
                    <Typography
                      sx={{
                        color: "#2f6df6",
                        fontFamily: "Roboto",
                        paddingLeft: "2%",
                      }}
                    >
                      {THEWITCHERWILDHUNT}
                    </Typography>
                  </Box>
                </ListItemButton>
              </List>
              <Typography
                variant="h4"
                sx={{
                  paddingLeft: "5%",
                  paddingRight: "8%",
                  paddingBottom: "5%",
                  marginTop: "-2%",
                  fontFamily: "Pirulen",
                  fontSize: "31pt",
                }}
              >
                SATISFY
                <br /> THE HUNTER WITHIN.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SliderPage;
